import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { EmissorOrderProductFilter, EmissorOrderStatusFilter, } from '../EmissorOrderFilters';
import styles from './EmissorRechargeReportDrawer.module.css';
import { ReportPeriodSection } from './ReportPeriodSection';
const TEST_ID_PREFIX = 'ReportByOrderStep';
const PRODUCT_TEST_ID_PREFIX = `${TEST_ID_PREFIX}Product`;
const STATUS_TEST_ID_PREFIX = `${TEST_ID_PREFIX}Status`;
export function ReportByOrderStep({ flow, today, productOptions }) {
    return (_jsxs("div", { className: styles.stepContent, "data-testid": `view${TEST_ID_PREFIX}`, children: [_jsx(ReportPeriodSection, { flow: flow, today: today, testIdPrefix: TEST_ID_PREFIX }), _jsx(EmissorOrderProductFilter, { options: productOptions, value: flow.productIds, onChange: flow.changeProductIds, testIdPrefix: PRODUCT_TEST_ID_PREFIX }), _jsx(EmissorOrderStatusFilter, { value: flow.screenStatuses, onChange: flow.changeScreenStatuses, testIdPrefix: STATUS_TEST_ID_PREFIX })] }));
}
